import LayoutComponent from '@/components/LayoutComponent';
import { IProductData } from '@/components/search-results/model';
import { Component, WidgetData } from '@/services/layout-service/models/layout';
import { Box } from '@mui/material';
import { useEffect, useState } from 'react';

type RelatedProductsProps = {
	products?: IProductData[];
};

const relatedProductsWidgetBase = {
	background: {
		type: 'FLAT',
		value: {
			color: 'gray -5',
		},
	},
	headers: {
		textContent: [
			[
				{
					color: 'gray -1',
					text: 'Related Products',
					typeScale: 'H9-Medium',
				},
			],
		],
	},
	components: [],
	template: {
		type: 'HORIZONTAL_LIST_1',
	},
	id: 22,
	widgetName: 'Spotlight Products Buy',
};

export const RelatedProducts = (props: RelatedProductsProps) => {
	const [relatedProductWidgetData, setRelatedProductWidgetData] =
		useState<WidgetData>(relatedProductsWidgetBase);

	const getComponentForRelatedProduct = (product: IProductData) => {
		return {
			type: 'RELATED_PRODUCT_PRODUCT_TILE',
			data: product,
		} as Component;
	};

	const generateRelatedProductWidget = () => {
		if (Array.isArray(props.products)) {
			const productTileComponents = props.products.map(
				getComponentForRelatedProduct
			);

			setRelatedProductWidgetData({
				...relatedProductWidgetData,
				components: productTileComponents,
			});
		}
	};

	useEffect(() => {
		generateRelatedProductWidget();
	}, [props.products]);

	return (
		<Box mb='48px'>
			<LayoutComponent
				widgets={[
					{
						id: 0,
						widgetName: 'PDP_RELATED_PRODUCTS',
						data: relatedProductWidgetData,
					},
				]}
			/>
		</Box>
	);
};
